import { render, staticRenderFns } from "./targeted.vue?vue&type=template&id=cdb0d024"
import script from "./targeted.vue?vue&type=script&lang=js"
export * from "./targeted.vue?vue&type=script&lang=js"
import style0 from "./targeted.vue?vue&type=style&index=0&id=cdb0d024&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports